import { orderBy } from 'lodash-es'

const tasks = orderBy([
  {
    value: 'FILE_EXCHANGE_EXECUTE',
    text: 'FILE EXCHANGE EXECUTE'
  }, {
    value: 'FILE_EXCHANGE_ABORT',
    text: 'FILE EXCHANGE ABORT'
  }, {
    value: 'SPECTRUM_ANALYSIS_EXECUTE',
    text: 'SPECTRUM ANALYSIS EXECUTE'
  }, {
    value: 'SPECTRUM_ANALYSIS_ABORT',
    text: 'SPECTRUM ANALYSIS ABORT'
  }, {
    value: 'UPDATE_EXECUTE',
    text: 'UPDATE EXECUTE'
  }, {
    value: 'UPDATE_ABORT',
    text: 'UPDATE ABORT'
  }, {
    value: 'SPECIFIC_COMMAND_EXECUTE',
    text: 'SPECIFIC COMMAND EXECUTE'
  }, {
    value: 'SPECIFIC_COMMAND_ABORT',
    text: 'SPECIFIC COMMAND ABORT'
  }, {
    value: 'MANAGEMENT_EXECUTE',
    text: 'MANAGEMENT EXECUTE'
  }, {
    value: 'MANAGEMENT_GET_VALUES',
    text: 'MANAGEMENT GET VALUES'
  }, {
    value: 'SET_CONFIGURATION',
    text: 'SET CONFIGURATION'
  }, {
    value: 'GET_CONFIGURATION',
    text: 'GET CONFIGURATION'
  }, {
    value: 'GET_CONFIGURATIONS',
    text: 'GET CONFIGURATIONS'
  }, {
    value: 'GET_STATISTICS',
    text: 'GET STATISTICS'
  }, {
    value: 'GET_VERSION',
    text: 'GET VERSION'
  }, {
    value: 'GET_VALUES',
    text: 'GET VALUES'
  }, {
    value: 'SET_VALUES',
    text: 'SET VALUES'
  }, {
    value: 'GET_CONTROLS',
    text: 'GET CONTROLS'
  }, {
    value: 'SET_CONTROLS',
    text: 'SET CONTROLS'
  }, {
    value: 'GET_LAN_MODULES',
    text: 'GET LAN MODULES'
  }
], ['text'])

const tasksStatuses = orderBy([
  {
    value: 'PENDING',
    text: 'PENDING'
  }, {
    value: 'OK',
    text: 'OK'
  }, {
    value: 'KO',
    text: 'KO'
  }
], ['text'])

// Export all by default
export default {
  tasks,
  tasksStatuses
}

// Export separate modules
export { tasks }
export { tasksStatuses }
